import { Component, Input } from "@angular/core";

@Component({
    selector: "m-loading",
    template: `
        <div class="text-center" [ngClass]="{ 'inline ml-1 mr-1': inline }">
            <p-progressSpinner [style]="{ width: diameterPx, height: diameterPx, 'vertical-align': 'middle' }"></p-progressSpinner>
        </div>
    `
})
export class LoadingComponent {
    @Input() diameterPx = "50px";
    @Input() inline = false;
}
